/** Значення поля як рядок для порівняння (особа чи посилання — ідентифікатор; порожнє — ''). */
const text = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object' && 'id' in (value as object)) return String((value as { id: unknown }).id ?? '');
  return String(value);
};

/**
 * Чи відповідають значення запису фільтру секції (синтаксис фільтра списку «поле:оператор:значення,…», умови через «;»): in, nin, eq,
 * neq, empty, filled; інші оператори не обмежують. Як у прототипі, порожнє значення не входить в «in» і входить у «nin» (контакт без
 * ролі — «Контакти»). Чиста функція.
 */
export function matchesFilter(values: Readonly<Record<string, unknown>>, filter: string): boolean {
  return filter.split(';').map((c) => c.trim()).filter(Boolean).every((condition) => {
    const [field = '', op = '', ...rest] = condition.split(':');
    const list = rest.join(':').split(',').map((v) => decodeURIComponent(v.trim())).filter(Boolean);
    const value = text(values[field]);
    switch (op) {
      case 'in': case 'eq': case 'is': return Boolean(value) && list.includes(value);
      case 'nin': case 'neq': case 'not': return !value || !list.includes(value);
      case 'empty': return !value;
      case 'filled': return Boolean(value);
      default: return true;
    }
  });
}
